import FadeIn from "./FadeIn";

export const SectionTitle = ({ overline, title, subtitle, align = "left" }) => (
  <FadeIn className={`mb-10 max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {overline && (
      <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#1E88E5]">{overline}</p>
    )}
    <h2 className="text-2xl font-extrabold tracking-tight text-[#0B3056] sm:text-3xl">{title}</h2>
    {subtitle && <p className="mt-3 text-base text-slate-600 md:text-lg">{subtitle}</p>}
  </FadeIn>
);

export default SectionTitle;
